/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useSelector } from 'react-redux';
import { getEntityType } from 'features/comments/commentsSlice';
import { selectedVersionStatus } from 'features/analyses/analysisSlice';
import { EntityType, VersioningProps } from './types';
import { AnalysisVersioning } from './analysis';
import { KFAVersioning } from './kfa';
import { StructuredAnalysisVersioning } from './structured-analysis';

const Components: Record<
  EntityType,
  (props: VersioningProps) => JSX.Element | null
> = {
  analysis: AnalysisVersioning,
  hypothesis: KFAVersioning,
  'quality-of-earnings': StructuredAnalysisVersioning,
  'net-working-capital': StructuredAnalysisVersioning,
  'debt-debt-like': StructuredAnalysisVersioning,
};

const Versioning: React.FunctionComponent<VersioningProps> = (props) => {
  const entityType = useSelector(getEntityType) as EntityType;
  const selectedVersion: { contentId: number } = useSelector(
    selectedVersionStatus
  );
  const { contentId } = selectedVersion || {};
  const versioningProps = {
    ...props,
    entityType,
    selectedContentId: contentId,
  };

  const Component = Components[entityType];

  if (Component) {
    return <Component {...versioningProps} />;
  }

  return null;
};

export default Versioning;
